module.exports = __webpack_public_path__ + "img/DS-1920.c0ba8887.jpg";